import React, { useState, useRef, useEffect } from "react";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import i18n from "i18next";
import { baseUrl } from "../../../helpers/constants";
import ArtikelDocuments from "./ArtikelDocuments";
import {
  createTableColumn,
  DataGrid,
  DataGridBody,
  DataGridCell,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridRow,
  Tab,
  TabList,
  Text,
} from "@fluentui/react-components";

interface IArtikelDetailsPanelProps {
  isPivot: boolean;
  artikelId: string;
  benennungDE: string;
  benennungEN: string;
}

function ArtikelDetailsPanel(props: IArtikelDetailsPanelProps) {
  const [sachwerte, setSachwerte] = useState([]);

  // Columns
  const columns = [
    // ------------Eigenschaft------------
    createTableColumn<any>({
      columnId: "eigenschaftId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("eigenschaft")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {i18n.language.includes("de") ? item.nameDE : item.nameEN}
          </Text>
        );
      },
    }),
    // ------------Wert------------
    createTableColumn<any>({
      columnId: "wertId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("wert")}</Text>;
      },
      renderCell: (item) => {
        let wert;
        if (item.typ == "NUMBER") {
          wert = parseFloat(item.wert).toLocaleString(undefined, {
            maximumFractionDigits: 3,
          });
        } else {
          wert = i18n.language.includes("de") ? item.wertDE : item.wertEN;
        }
        return (
          <div className="lueb-centerVertical">
            <Text>{wert}</Text>
          </div>
        );
      },
    }),
    // ------------mengeneinheitId------------
    createTableColumn<any>({
      columnId: "mengeneinheitId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("mengeneinheit")}</Text>;
      },
      renderCell: (item) => {
        return <Text>{item.mengeneinheit}</Text>;
      },
    }),
  ];

  const [selectedTabValue, setSelectedTabValue] = useState<string>("tech");
  const getSachwerte = () => {
    if (props.artikelId) {
      fetchWrapper
        .postWithAuth(`${baseUrl}/api/sachwert/byquery`, {
          artikelId: props.artikelId,
        })
        .then((result: any) => {
          setSachwerte(result);
        });
    }
  };

  useEffect(() => {
    if (props.artikelId != "") {
      getSachwerte();
    }
  }, [props.artikelId]);

  const refContentDiv = useRef<HTMLHeadingElement>(null);

  useEffect(() => {}, [refContentDiv.current]);

  return (
    <div className="lueb-ContentBlock">
      <TabList
        style={{ marginBottom: "15px" }}
        selectedValue={selectedTabValue}
        onTabSelect={(ev, data) => {
          if (typeof data.value == "string") {
            setSelectedTabValue(data.value);
          }
        }}
      >
        <Tab value={"tech"}>{i18n.t<string>("technicalData")}</Tab>
        <Tab value={"doc"}>{i18n.t<string>("documents")}</Tab>
      </TabList>
      {selectedTabValue == "tech" && (
        <DataGrid columns={columns} items={sachwerte}>
          <DataGridHeader>
            <DataGridRow>
              {({ renderHeaderCell }) => (
                <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
              )}
            </DataGridRow>
          </DataGridHeader>
          <DataGridBody<any>>
            {({ item, rowId }) => (
              <DataGridRow<any> key={rowId}>
                {({ renderCell }) => (
                  <DataGridCell>{renderCell(item)}</DataGridCell>
                )}
              </DataGridRow>
            )}
          </DataGridBody>
        </DataGrid>
      )}
      {selectedTabValue == "doc" && (
        <ArtikelDocuments artikelId={props.artikelId} />
      )}
    </div>
  );
}

export default ArtikelDetailsPanel;
